import { I as IFRAME_LOADED_MESSAGE } from '../../dist/consts-ba3014f5.esm.js';

function initLoadPopup() {
  var html = document.querySelector('html');
  var popupContainer = document.querySelector('#popup-container');

  if (!popupContainer) {
    return;
  }

  var delay = Number(popupContainer.dataset.popupDelay);
  var urlToLoad = popupContainer.dataset.popupUrl;
  var iframe = popupContainer.querySelector('iframe');
  var closeButton = popupContainer.querySelector('[data-role="close-button"]');
  var backdrop = popupContainer.querySelector('[data-role="backdrop"]');

  if (iframe && urlToLoad) {
    setTimeout(function () {
      iframe.src = urlToLoad;
    }, delay);
    showPopupWhenIFrameLoaded();
  }

  closeButton === null || closeButton === void 0 ? void 0 : closeButton.addEventListener('click', closePopup);

  function applyOverlayToPage() {
    backdrop === null || backdrop === void 0 ? void 0 : backdrop.classList.add('overlay-active');
  }

  function preventScrollOnHtml() {
    html === null || html === void 0 ? void 0 : html.classList.add('prevent-scroll');
  }

  function allowScrollOnHtml() {
    html === null || html === void 0 ? void 0 : html.classList.remove('prevent-scroll');
  }

  function removeHiddenClass() {
    popupContainer === null || popupContainer === void 0 ? void 0 : popupContainer.classList.remove('hidden');
  }

  function closePopup() {
    allowScrollOnHtml();
    popupContainer === null || popupContainer === void 0 ? void 0 : popupContainer.remove();
    backdrop === null || backdrop === void 0 ? void 0 : backdrop.remove();
  }

  function showPopupWhenIFrameLoaded() {
    window.addEventListener('message', function (event) {
      if (event.data === IFRAME_LOADED_MESSAGE) {
        applyOverlayToPage();
        removeHiddenClass();
        preventScrollOnHtml();
      }
    });
  }
}

export { initLoadPopup };
